import { ActionType, ActionTypes, State } from './types';

const initialState = {
  isLoading: false,
  mustUpdate: false,
  error: '',
  data: undefined,
};

const legacyUserStatusReducer = (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case ActionTypes.FETCH_USER_STATUS_START:
      return {
        ...state,
        isLoading: true,
        mustUpdate: false,
      };
    case ActionTypes.FETCH_USER_STATUS_UPDATE:
      return {
        ...state,
        mustUpdate: true,
      };
    case ActionTypes.FETCH_PROMOTION_RESET:
      return {
        ...state,
        lastPromotionGenerator: null,
        isUserBlocked: undefined,
      };
    case ActionTypes.FETCH_PROMOTION_OK:
      return {
        ...state,
        lastPromotionGenerator: Date.now().toString(),
        isUserBlocked: action.payload,
      };
    case ActionTypes.FETCH_USER_STATUS_SUCCESS:
      return {
        ...state,
        data: {
          ...state?.data,
          ...action.payload,
        },
      };
    case ActionTypes.FETCH_USER_STATUS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case ActionTypes.UPDATE_PROMOTIONS_AVAILABLE:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state?.data,
          invitationCount: action.payload,
        },
      };
    case ActionTypes.UPDATE_TAGS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state?.data,
          tags: action.payload,
        },
      };
    case ActionTypes.CLEAN_USER_STATUS:
      return initialState;
    default:
      return state;
  }
};

export default legacyUserStatusReducer;
